import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Bento} from '@primer/react-brand'
`}</code></pre>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box
  style={{backgroundColor: 'var(--base-color-scale-gray-2)'}}
  padding="normal"
>
  <Bento>
    <Bento.Item />
    <Bento.Item />
    <Bento.Item />
  </Bento>
</Box>
`}</code></pre>
    <h3>{`Example layout`}</h3>
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box
  style={{backgroundColor: 'var(--base-color-scale-gray-2)'}}
  padding="normal"
>
  <Bento>
    <Bento.Item columnSpan={12} rowSpan={2} />
    <Bento.Item columnSpan={7} rowSpan={2} />
    <Bento.Item columnSpan={5} rowSpan={2} />
    <Bento.Item columnSpan={12} rowSpan={2} />
  </Bento>
</Box>
`}</code></pre>
    <h3>{`Dark mode items`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Bento>
  <Bento.Item columnSpan={7} rowSpan={2} colorMode="dark" />
  <Bento.Item columnSpan={5} rowSpan={2} colorMode="dark" />
  <Bento.Item columnSpan={12} rowSpan={2} colorMode="dark" />
  <Bento.Item columnSpan={12} rowSpan={2} colorMode="dark" />
</Bento>
`}</code></pre>
    <h3>{`Responsive behavior`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`columnSpan`}</inlineCode>{`, `}<inlineCode parentName="p">{`rowSpan`}</inlineCode>{`, `}<inlineCode parentName="p">{`columnStart`}</inlineCode>{`, `}<inlineCode parentName="p">{`rowStart`}</inlineCode>{`, `}<inlineCode parentName="p">{`flow`}</inlineCode>{`, `}<inlineCode parentName="p">{`verticalAlign`}</inlineCode>{`, `}<inlineCode parentName="p">{`horizontalAlign`}</inlineCode>{` with an `}<inlineCode parentName="p">{`Object`}</inlineCode>{` of breakpoint-specific keys and values corresponding to each type to enable responsive behavior for each of these properties.`}</p>
    <p>{`Breakpoints use `}<inlineCode parentName="p">{`min-width`}</inlineCode>{`, where it will also apply your chosen `}<inlineCode parentName="p">{`span`}</inlineCode>{` value to all larger breakpoints.`}</p>
    <Note mdxType="Note">
  Bento items can render in a different source order to what is presented
  visually. It's important to ensure that the content of each item is
  self-contained and can be read independently of its adjacent items.
    </Note>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box
  style={{backgroundColor: 'var(--base-color-scale-gray-2)'}}
  padding="normal"
>
  <Bento>
    <Bento.Item
      columnSpan={{
        xsmall: 12,
        small: 6,
        large: 3,
      }}
      rowSpan={{
        xsmall: 4,
        large: 4,
      }}
    />
    <Bento.Item
      columnSpan={{
        xsmall: 12,
        small: 6,
        large: 3,
      }}
      rowSpan={{
        xsmall: 4,
        large: 2,
      }}
    />
    <Bento.Item
      columnSpan={{
        xsmall: 12,
        small: 6,
        large: 6,
      }}
      rowSpan={{
        xsmall: 4,
        large: 4,
      }}
    />
    <Bento.Item
      columnSpan={{
        xsmall: 12,
        small: 6,
        large: 3,
      }}
      rowSpan={{
        xsmall: 4,
        large: 3,
      }}
      rowStart={{
        large: 5,
      }}
    />
    <Bento.Item
      columnSpan={{
        xsmall: 12,
        small: 6,
        large: 3,
      }}
      rowSpan={{
        xsmall: 4,
        large: 5,
      }}
    />
    <Bento.Item
      columnSpan={{
        xsmall: 12,
        small: 6,
        large: 6,
      }}
      rowSpan={{
        xsmall: 4,
        large: 3,
      }}
    />
  </Bento>
</Box>
`}</code></pre>
    <h4>{`Responsive flow`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box
  style={{backgroundColor: 'var(--base-color-scale-gray-2)'}}
  padding="normal"
>
  <Bento>
    <Bento.Item
      flow={{
        xsmall: 'row',
        small: 'row',
        medium: 'column',
      }}
    >
      <Bento.Content padding="normal">
        <Bento.Heading as="h3">Heading</Bento.Heading>
        <Link href="#">Call to action</Link>
      </Bento.Content>
      <Bento.Visual>
        <img
          alt="placeholder, blank area with an gray background color"
          src="https://via.placeholder.com/600x400/f5f5f5/f5f5f5.png"
        />
      </Bento.Visual>
    </Bento.Item>
  </Bento>
</Box>
`}</code></pre>
    <h2>{`Component props`}</h2>
    <h3>{`Bento`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sets a custom class on the root element`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The Bento component API supports all standard HTML attribute props for the interface `}<inlineCode parentName="p">{`HTMLDivElement`}</inlineCode>{`.`}</p>
    <h3>{`Bento.Item`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sets a custom class on the root element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode>{`, `}<inlineCode parentName="td">{`React.ReactNode[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The children to be rendered within the `}<inlineCode parentName="td">{`Bento.Item`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`columnStart`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`1`}</inlineCode>{`, `}<inlineCode parentName="td">{`2`}</inlineCode>{`, `}<inlineCode parentName="td">{`3`}</inlineCode>{`, `}<inlineCode parentName="td">{`4`}</inlineCode>{`, `}<inlineCode parentName="td">{`5`}</inlineCode>{`, `}<inlineCode parentName="td">{`6`}</inlineCode>{`, `}<inlineCode parentName="td">{`7`}</inlineCode>{`, `}<inlineCode parentName="td">{`8`}</inlineCode>{`, `}<inlineCode parentName="td">{`9`}</inlineCode>{`, `}<inlineCode parentName="td">{`10`}</inlineCode>{`, `}<inlineCode parentName="td">{`11`}</inlineCode>{`, `}<inlineCode parentName="td">{`12`}</inlineCode>{`, `}<inlineCode parentName="td">{`ResponsiveColumnIndex`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The column number in which this content should start`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`columnSpan`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`1`}</inlineCode>{`, `}<inlineCode parentName="td">{`2`}</inlineCode>{`, `}<inlineCode parentName="td">{`3`}</inlineCode>{`, `}<inlineCode parentName="td">{`4`}</inlineCode>{`, `}<inlineCode parentName="td">{`5`}</inlineCode>{`, `}<inlineCode parentName="td">{`6`}</inlineCode>{`, `}<inlineCode parentName="td">{`7`}</inlineCode>{`, `}<inlineCode parentName="td">{`8`}</inlineCode>{`, `}<inlineCode parentName="td">{`9`}</inlineCode>{`, `}<inlineCode parentName="td">{`10`}</inlineCode>{`, `}<inlineCode parentName="td">{`11`}</inlineCode>{`, `}<inlineCode parentName="td">{`12`}</inlineCode>{`, `}<inlineCode parentName="td">{`ResponsiveColumnIndex`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The number of columns this content should span`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`rowStart`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`number`}</inlineCode>{`, `}<inlineCode parentName="td">{`ResponsiveRowIndex`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The row number in which this content should start`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`rowSpan`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`number`}</inlineCode>{`, `}<inlineCode parentName="td">{`ResponsiveRowIndex`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The number of rows this content should span`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`flow`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"row"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"column"`}</inlineCode>{`, `}<inlineCode parentName="td">{`ResponsiveFlow`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The flow of the `}<inlineCode parentName="td">{`Bento.Content`}</inlineCode>{` and `}<inlineCode parentName="td">{`Bento.Visual`}</inlineCode>{` within the `}<inlineCode parentName="td">{`Bento.Item`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`colorMode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"light"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"dark"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`"light"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The color mode specified for this `}<inlineCode parentName="td">{`Bento.Item`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`visualAsBackground`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Determines if the `}<inlineCode parentName="td">{`Bento.Visual`}</inlineCode>{` child element is set as the background for the `}<inlineCode parentName="td">{`Bento.Item`}</inlineCode>{` with the `}<inlineCode parentName="td">{`Bento.Content`}</inlineCode>{` overlayed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`order`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"default"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"reversed"`}</inlineCode>{`, `}<inlineCode parentName="td">{`ResponsiveOrder`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`default`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Determines the visual order for the `}<inlineCode parentName="td">{`Bento.Item`}</inlineCode>{`. This changes the semantic ordering of elements for accessibility.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The Bento.Item component API supports all standard HTML attribute props for the interface `}<inlineCode parentName="p">{`HTMLDivElement`}</inlineCode>{`, while providing some additional behavior as described above.`}</p>
    <h3>{`Bento.Content`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sets a custom class on the root element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://primer.style/brand/components/Text"
            }}><inlineCode parentName="a">{`Text`}</inlineCode></a>{`,`}<inlineCode parentName="td">{`Bento.Heading`}</inlineCode>{`, `}<a parentName="td" {...{
              "href": "https://primer.style/brand/components/Link"
            }}><inlineCode parentName="a">{`Link`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The children to be rendered within the `}<inlineCode parentName="td">{`Bento.Content`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`leadingVisual`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ReactElement`}</inlineCode>{`, `}<inlineCode parentName="td">{`Icon`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sets the icon before the heading text`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`padding`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"condensed"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"normal"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"spacious"`}</inlineCode>{`, `}<inlineCode parentName="td">{`ResponsivePadding`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`"normal"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sets a custom class on the root element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`horizontalAlign`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"start"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"center"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"end"`}</inlineCode>{`, `}<inlineCode parentName="td">{`ResponsiveAlign`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`"start"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The horizontal alignment of children within the `}<inlineCode parentName="td">{`Bento.Content`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`verticalAlign`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"start"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"center"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"end"`}</inlineCode>{`, `}<inlineCode parentName="td">{`ResponsiveAlign`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`"start"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The vertical alignment of children within the `}<inlineCode parentName="td">{`Bento.Content`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The Bento.Content component API supports all standard HTML attribute props for the interface `}<inlineCode parentName="p">{`HTMLDivElement`}</inlineCode>{`, while providing some additional behavior as described above.`}</p>
    <h3>{`Bento.Heading`}</h3>
    <p>{`Required node that is used to provide a heading for the `}<inlineCode parentName="p">{`Bento.Content`}</inlineCode>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom class name for the heading component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ReactNode`}</inlineCode>{`, `}<inlineCode parentName="td">{`ReactNode[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Content to be displayed inside the heading component.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Forwards all props from the `}<a parentName="p" {...{
        "href": "/components/Heading"
      }}>{`Heading component`}</a>{`, including `}<inlineCode parentName="p">{`as`}</inlineCode>{`, `}<inlineCode parentName="p">{`size`}</inlineCode>{`, and `}<inlineCode parentName="p">{`weight`}</inlineCode>{`.`}</p>
    <h3>{`Bento.Visual`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sets a custom class on the root element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`fillMedia`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Determines how the visual reacts within its container. Either filling the container or contained within.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`position`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`"50% 50%"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The positioning of the visual.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`padding`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"condensed"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"normal"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"spacious"`}</inlineCode>{`, `}<inlineCode parentName="td">{`ResponsivePadding`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sets a custom class on the root element`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The Bento.Visual component API supports all standard HTML attribute props for the interface `}<inlineCode parentName="p">{`HTMLDivElement`}</inlineCode>{`, while providing some additional behavior as described above.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      